export default function worstRatedSongs() {
  const data = $("#worst-rated-songs").data("worstRates");
  return {
    type: "bar",
    canvasID: "worst-rated-songs",
    options: {
      indexAxis: "y",
      layout: {
        padding: 20,
      },
      interaction: {
        mode: "nearest",
        intersect: false,
      },
      scales: {
        x: { grid: { display: false } },
      },
      plugins: {
        legend: {
          display: false,
          position: "right",
        },
        title: {
          display: true,
          text: "Musicas pior avaliadas",
        },
      },
    },
    data: {
      label: "Avaliações negativas",
      labels: Object.keys(data),
      datasets: [
        {
          data: Object.values(data),
          backgroundColor: [
            "rgba(94, 40, 89, 0.2)",
            "rgba(177, 211, 55, 0.2)",
            "rgba(241, 195, 51, 0.2)",
            "rgba(202, 158, 76, 0.2)",
            "rgba(222, 44, 43, 0.2)",
          ],
          borderColor: [
            "rgba(94, 40, 89, 1)",
            "rgba(177, 211, 55, 1)",
            "rgba(241, 195, 51, 1)",
            "rgba(202, 158, 76, 1)",
            "rgba(222, 44, 43, 1)",
          ],
          borderWidth: 1,
        },
      ],
    },
  };
}
